export default __webpack_public_path__ + "static/media/legislativa.ab901c2e.jpg";